import type { Registry as Services } from '@ember/service';
import { tKey } from 'ember-intl';

interface FormatRestrictionValueOptions {
  intl: Services['intl'];
  value: number | null | undefined;
}

const MIN_LOS_KEY = tKey('pricing_assistant.stay_restrictions.min_los');
const NO_MIN_LOS_KEY = tKey('pricing_manager.restrictions.no_min_los');

/**
 * Formats a MinLOS value for display: `null`/`undefined` -> "--", `0` -> "No MinLOS restriction",
 * else -> "MinLOS {count}".
 */
export function formatMinLosValue({
  intl,
  value,
}: FormatRestrictionValueOptions): string {
  if (value == null) {
    return intl.t('general.missing');
  }

  if (value === 0) {
    return intl.t(NO_MIN_LOS_KEY);
  }

  return intl.t(MIN_LOS_KEY, {
    count: value,
  });
}

/**
 * Formats an overbooking value for display: `null`/`undefined` -> "--", else -> the raw number.
 */
export function formatOverbookingValue({
  intl,
  value,
}: FormatRestrictionValueOptions): number | string {
  if (value == null) {
    return intl.t('general.missing');
  }

  return value;
}
